import type { ChatbooksEnvironment } from '../config/apiConfig';

export type BookSize = '6x6' | '8x8' | '10x10';
export type CoverType = 'Softcover' | 'Hardcover';

export interface FlowState {
  name: string;
  email: string;
  password: string;
  phoneNumber: string;
  smsConsent: boolean;
  termsConsent: boolean;
  accessToken: string;
  personId: string;
  displayName: string;
  chatbooksEnvironment: ChatbooksEnvironment;
  sessionId: string;
  sessionKey: string;
  bookSize: BookSize;
  coverType: CoverType;
  sessionTitle: string;
  specialInstructions: string;
  authMethod: 'email' | 'google' | 'apple' | null;
}

export const DEFAULT_FLOW_STATE: FlowState = {
  name: '',
  email: '',
  password: '',
  phoneNumber: '',
  smsConsent: true,
  termsConsent: false,
  accessToken: '',
  personId: '',
  displayName: '',
  chatbooksEnvironment: (process.env.REACT_APP_CHATBOOKS_ENV === 'staging'
    ? 'staging'
    : 'production') as ChatbooksEnvironment,
  sessionId: '',
  sessionKey: '',
  bookSize: '6x6',
  coverType: 'Softcover',
  sessionTitle: '',
  specialInstructions: '',
  authMethod: null,
};

export const FLOW_STORAGE_KEY = 'cb-studio-web-flow-v1';
